import { render, staticRenderFns } from "./PicklResponses.vue?vue&type=template&id=0a4be550&"
import script from "./PicklResponses.vue?vue&type=script&lang=ts&"
export * from "./PicklResponses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4be550')) {
      api.createRecord('0a4be550', component.options)
    } else {
      api.reload('0a4be550', component.options)
    }
    module.hot.accept("./PicklResponses.vue?vue&type=template&id=0a4be550&", function () {
      api.rerender('0a4be550', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/PicklResponses.vue"
export default component.exports